import Image from 'next/image';
import { Box, Button } from '@react/chakra';

import type { JSX } from 'react';

import { KofiModal } from './KofiModal';

export function KofiButton(): JSX.Element {
  return (
    <KofiModal
      trigger={
        <Button
          w='160px'
          border={0}
          height='50px'
          color='white'
          fontWeight='bold'
          bgSize='400% 400%'
          transition='all .3s ease'
          bgGradient='linear-gradient(25deg, #d350db, {colors.teal.500}, #d350db)'
          _hover={{
            bgPos: '50% 0',
          }}
        >
          <Box h='50px' w='50px' objectFit='contain' asChild>
            <Image
              width={50}
              height={50}
              alt='kofi-icon.webp'
              src='/kofi-icon.webp'
            />
          </Box>
          Ko-fi me
        </Button>
      }
    />
  );
}
